(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeDetailController', PracticeDetailController);

    PracticeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Practice', 'Calendar', 'Practitioner', 'PracticeProfile', '$uibModal'];

    function PracticeDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Practice, Calendar, Practitioner, PracticeProfile, $uibModal) {
        var vm = this;

        vm.practice = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.showExternalCalendarInfo = showExternalCalendarInfo;
        vm.isExternalCalendar = isExternalCalendar;

        function showExternalCalendarInfo() {
            var externalCalendarInfo = Practice.getExternalCalendarInfo({id: vm.practice.id});

            $uibModal.open({
                template: '<div class="modal-body pad"><span style="white-space: pre-wrap;">{{vm.externalCalendarInfo.info}}</span></div>',
                controller: function() { var vm = this; vm.externalCalendarInfo = externalCalendarInfo; },
                controllerAs: 'vm',
                size: 'lg'
            });
        }

        function isExternalCalendar() {
            return vm.practice.calendarType !== 'ZUMEDO';
        }

        var unsubscribe = $rootScope.$on('getwellApp:practiceUpdate', function(event, result) {
            vm.practice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
